import { render, staticRenderFns } from "./HealthLoadingState.vue?vue&type=template&id=518272d9&"
import script from "./HealthLoadingState.vue?vue&type=script&lang=ts&"
export * from "./HealthLoadingState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports